var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "reveal boss-modal-container-resume",
      attrs: { id: "boss-modal-control-" + _vm.userId, "data-reveal": "" },
      on: { scroll: _vm.onScroll },
    },
    [
      _c(
        "h2",
        {
          staticClass: "boss-title",
          attrs: { "data-test": "resume-updated-date" },
        },
        [
          _vm._v(
            "\n    会員レジュメ（" + _vm._s(_vm.resumeUpdateDate) + "更新）\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "boss-resumecard-item" },
        [
          _c("scout-resume-card-avatar", {
            attrs: {
              id: _vm.userId,
              member: _vm.member,
              "is-show-checkbox": false,
              "is-scout-decline": _vm.isScoutDecline,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "boss-resumecard-item-right" }, [
            _c("div", { staticClass: "boss-resumecard-details" }, [
              _c(
                "div",
                { staticClass: "boss-resumecard-overview clearfix" },
                [
                  _c("scout-resume-member-summary", {
                    staticClass: "boss-resumecard-overview-title",
                    attrs: { member: _vm.member },
                  }),
                  _vm._v(" "),
                  _c(
                    "dl",
                    { staticClass: "boss-resumecard-overview-list clearfix" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "dd",
                        {
                          staticClass:
                            "boss-resumecard-overview-body boss-ellipsis-block",
                          attrs: {
                            "data-test": "member_experienced_occupation",
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("parseBlankForDefaultValue")(
                                  _vm.presentOccupation
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "dl",
                    { staticClass: "boss-resumecard-overview-list clearfix" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "dd",
                        {
                          staticClass:
                            "boss-resumecard-overview-body boss-ellipsis-block",
                          attrs: { "data-test": "member_desired_occupation" },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("parseBlankForDefaultValue")(
                                  _vm.convertObjectLabel(
                                    _vm.member.desiredOccupations
                                  )
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "boss-layout boss-layout-no-gap" }, [
                    _c("dl", { staticClass: "boss-resumecard-overview-list" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "dd",
                        {
                          staticClass:
                            "boss-resumecard-overview-body boss-ellipsis-block",
                          attrs: {
                            "data-test": "member_desired_work_prefecture",
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm._f("parseBlankForDefaultValue")(
                                  _vm.convertPrefectureLabel(
                                    _vm.member.desiredWorkPrefectures
                                  )
                                )
                              ) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isMaskingTarget
        ? _c("scout-member-career-resume", { attrs: { member: _vm.member } })
        : _c(
            "div",
            { staticClass: "margin-top-1", attrs: { "data-test": "masking" } },
            [_vm._v("\n    " + _vm._s(_vm.maskingLabel) + "\n  ")]
          ),
      _vm._v(" "),
      _vm.showDetail
        ? [
            _c("scout-member-comment", {
              attrs: { "user-id": _vm.userId, comment: _vm.comment },
              on: { "update-comment": _vm.updateComment },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.contractId && _vm.showDetail
        ? [
            _c("scout-member-scout-summary", {
              attrs: { "user-id": _vm.userId, "contract-id": _vm.contractId },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.contractId && _vm.jobId && _vm.showDetail
        ? [
            _c("scout-member-scout-history", {
              attrs: {
                "contract-id": _vm.contractId,
                "job-id": _vm.jobId,
                "user-id": _vm.userId,
                "data-test": "scout-history",
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("button", {
        staticClass: "close-button boss-close-button boss-icon-cross",
        attrs: {
          "data-close": "",
          "aria-label": "Close modal",
          type: "button",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "boss-modal-close" }, [
        _vm.isShowCheckedCloseButton
          ? _c(
              "button",
              {
                staticClass:
                  "boss-button-center boss-button-large boss-modal-selected-close-button",
                attrs: {
                  "data-close": "",
                  "aria-label": "Close modal",
                  type: "button",
                  "data-test": "checked-close-button",
                },
                on: { click: _vm.check },
              },
              [_vm._v("\n      選択して閉じる\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showsExcludedButton
          ? _c(
              "button",
              {
                staticClass: "boss-button-center boss-button-large",
                attrs: {
                  "data-close": "",
                  "aria-label": "Close modal",
                  type: "button",
                  "data-test": "excluded-close-button",
                },
                on: { click: _vm.registerExcludedMember },
              },
              [_vm._v("\n      除外者へ\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "boss-button-center boss-button-large boss-modal-close-button",
            attrs: {
              "data-close": "",
              "aria-label": "Close modal",
              type: "button",
              "data-test": "close-button",
            },
          },
          [_vm._v("\n      閉じる\n    ")]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            directives: [
              {
                name: "scroll-to",
                rawName: "v-scroll-to",
                value: {
                  element: "#boss-modal-control-" + _vm.userId,
                  container: "#boss-modal-control-" + _vm.userId,
                  duration: 500,
                },
                expression:
                  "{ element: `#boss-modal-control-${userId}`, container: `#boss-modal-control-${userId}`, duration: 500 }",
              },
            ],
            staticClass: "boss-top-scroll",
            attrs: { "data-test": "scroll-top" },
          },
          [
            _c("span", { staticClass: "boss-icon-triangle-up" }),
            _vm._v(" "),
            _c("span", { staticClass: "boss-top-scroll-text" }, [
              _vm._v("上まで戻る"),
            ]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "boss-resumecard-overview-item" }, [
      _c("span", { staticClass: "boss-resumecard-head" }, [
        _vm._v("直近の経験職種"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "boss-resumecard-overview-item" }, [
      _c("span", { staticClass: "boss-resumecard-head" }, [_vm._v("希望職種")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "boss-resumecard-overview-item" }, [
      _c("span", { staticClass: "boss-resumecard-head" }, [
        _vm._v("希望勤務地"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }